export default "__VITE_ASSET__D67GhACy__"